export enum USER_ACTION_TYPES {
  SET_CURRENT_USER = 'SET_CURRENT_USER',
  CHECK_USER_SESSION = 'CHECK_USER_SESSION',
  GOOGLE_SIGN_IN = 'GOOGLE_SIGN_IN',
  EMAIL_SIGN_IN = 'EMAIL_SIGN_IN',
  SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS',
  SIGN_IN_FAILED = 'SIGN_IN_FAILED',
  USER_SIGN_OUT = 'USER_SIGN_OUT',
  USER_SIGN_UP = 'USER_SIGN_UP',
}


